<div role="group" [ngClass]="styles.multiSelectGroup">
	<button type="button" [ngClass]="[styles.multiSelectButton, styles.vbSecondaryBtn, value && value[mk] ? styles.multiSelectActive : '']" [disabled]="disabled" *ngFor="let mk of modelKeys" (click)="onClick(mk)">
		{{ labelMap[mk] }}
	</button>
</div>
